<template>
  <div class="row user-data">
    <div class="col s5 l12 user-avatar">
      <img :src="avatarUrl" class="circle responsive-img"/>
    </div>
    <div class="col s7 l12 user-info">
      <span class="full-name">
        <span class="first-name">{{ getUser.first_name }}</span>
        <span class="last-name">{{ getUser.last_name }}</span>
      </span>
      <p class="user-email">{{ getUser.email }}</p>
    </div>
    <div class="col s12 m12 l12 share-code" v-if="!showForRole('accountant')" >
      <p>
        <i class="mfind-icon-info icon"></i>
        Link do produktu
      </p>
      <input-promo-url type="text" name="promo_url" label="Kod do promowania" />
    </div>
    <Loader :loading="getUserPending" type=""/>
  </div>
</template>

<script>
import InputPromoUrl from '@/components/inputs/promoUrl'
import Loader from '@/components/loader'
import { userHasRole } from '@/services/helper'
import md5 from 'md5'
import { mapGetters } from 'vuex'
export default {
  components: { InputPromoUrl, Loader },
  created () {
    if (this.isLoggedIn) {
      this.$store.dispatch('getUser')
    }
  },
  methods: {
    showForRole (role) {
      return userHasRole(this.getUserRoles, role)
    }
  },
  computed: {
    ...mapGetters([
      'getUser', 'getUserPending', 'isLoggedIn', 'getUserRoles'
    ]),
    avatarUrl () {
      let hash = ''
      if (this.getUser && this.getUser.email) hash = md5(this.getUser.email)
      return `https://www.gravatar.com/avatar/${hash}?s=100&d=mm`
    }
  }
}
</script>

<style lang="scss">
@import 'src/stylesheets/variables';
.user-data {
  color: $fullname-text-color;
  padding: 20px 10px;
  margin: 0;

  .full-name {
    font-family: 'latoblack';
    font-size: 20px;
    line-height: 23px;
  }

  .user-email {
    color: $not-important-text-color;
    font-size: 11px;
  }

  .user-avatar {
    text-align: center;
    position: relative;

    .mfind-icon-edit {
      color: $default-link-text-color;
      position: absolute;
      bottom: 0;
      right: 0;
      width: 34px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      background-color: #fff;
      font-size: 18px;
    }
  }

  .share-code {
    text-align: center;

    p {
      color: $fullname-text-color;
      font-family: 'latoblack';
      font-size: 1.2em;
      letter-spacing: -1px;
      line-height: 23px;
    }
    .icon {
      color: #ccc;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// userInfo.vue?791e207e